export default () => ({
  componentName: 'cell-name-and-icon',
});
